import React from "react";
import { Container, Typography } from "@mui/material";
import ManagerLayout from "../../layouts/ManagerLayout"; // or your ManagerLayout

const ManagerDashboard = () => (
  <ManagerLayout>
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Manager Dashboard
      </Typography>
      {/* manager-specific widgets go here */}
    </Container>
  </ManagerLayout>
);

export default ManagerDashboard;
